import { Controller } from "@hotwired/stimulus"

// Wraps a <details class="dropdown"> element and closes it when the user
// clicks outside of it or presses Escape.
export default class extends Controller {
  connect() {
    this.onDocumentClick = this.onDocumentClick.bind(this)
    this.onKeydown = this.onKeydown.bind(this)
    document.addEventListener("click", this.onDocumentClick)
    document.addEventListener("keydown", this.onKeydown)
  }

  disconnect() {
    document.removeEventListener("click", this.onDocumentClick)
    document.removeEventListener("keydown", this.onKeydown)
  }

  onDocumentClick(event) {
    if (!this.element.hasAttribute("open")) return
    if (this.element.contains(event.target)) return
    this.close()
  }

  onKeydown(event) {
    if (event.key === "Escape" && this.element.hasAttribute("open")) {
      this.close()
    }
  }

  close() {
    this.element.removeAttribute("open")
  }
}
